export default __webpack_public_path__ + "static/media/retiro-2022.ae82d973.png";